import * as React from 'react'
import { ButtonToggle } from '../ButtonToggle'

const styles = require('./styles.scss')
export interface ButtonToggleListProps {
  badges: ButtonToggle[]
  title?: string
  toggleBadge?: (toggle: ButtonToggle) => void
}

export const ButtonToggleList: React.FC<ButtonToggleListProps> = ({ badges: visibleBadges, title, toggleBadge }) => {
  const badges: JSX.Element[] = []
  visibleBadges?.forEach((badge) =>
    badges.push(
      <ButtonToggle className={styles.badgeToggle} onClick={toggleBadge} key={`${badge?.value}`} badge={badge} />,
    ),
  )

  return (
    <div className={styles.badgesListContainer}>
      {title && <h4 className={styles.badgesListTitle}>{title}</h4>}
      <div className={styles.badgesContainer}>{badges}</div>
    </div>
  )
}
